<div [formGroup]="form" fxLayout="column" fxLayoutGap="10px">
	<mat-form-field>
		<input
			autocomplete="email"
			matInput
			placeholder="Email Address"
			formControlName="email"
			required
		/>
		<mat-error *ngIf="form.get('email').hasError('required')"
			>Required</mat-error
		>
		<mat-error *ngIf="form.get('email').hasError('email')">
			Invalid email address.
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			autocomplete="description"
			matInput
			placeholder="Description"
			formControlName="description"
		/>
	</mat-form-field>
	<mat-checkbox formControlName="isPrimary" fxFlex="100%">
		Is Primary Email Address
	</mat-checkbox>
</div>
